import { similarityLegendItems, trendLegendItems } from "../config/colorScale";
import { ColorMode } from "../types";

const ColorLegends = ({ colorMode, showCenterMarker = false }: {
  colorMode: ColorMode,
  // Show the Cluster Weighted Average (diamond) entry. Only the SEO chart with a
  // computed center sets this; GEO / empty clusters leave it off.
  showCenterMarker?: boolean,
}) => {
  const tailwindClasses = {
    container: "flex items-start gap-1.5",
    circle: "rounded-full aspect-square h-[11px] mt-0.5",
    text: "font-semibold text-xs text-neutral-500 leading-[1.3]"
  }

  return (
    <div 
      className={`grid mt-7 mb-6`}
      style={{
        // + 1 for the Anchor Keyword entry, + 1 more when the center marker shows.
        gridTemplateColumns: `repeat(${(colorMode === 'trend' ? trendLegendItems.length : similarityLegendItems.length) + (showCenterMarker ? 2 : 1)}, minmax(0, 1fr))`
      }}
    >
      {colorMode === 'trend' ? (
        <>
          {trendLegendItems.map((i, idx) => (
            <div key={idx} className={tailwindClasses.container}>
              <div 
                className="rounded-full aspect-square h-[11px] mt-0.5" 
                style={{
                  backgroundColor: i.color,
                }}  
              />
              <div 
                className={tailwindClasses.text} 
                dangerouslySetInnerHTML={{ __html: i.label }} 
              />
            </div>
          ))}
        </>
      ) : (
        <>
          {similarityLegendItems.map((i) => (
            <div className={tailwindClasses.container}>
              <div 
                className={tailwindClasses.circle}
                style={{
                  backgroundColor: i.color
                }}
              />
              <div className={tailwindClasses.text}>{i.label}</div>
            </div>
          ))}
        </>
      )}
      
      <div className={tailwindClasses.container}>
        <div className="rounded-full bg-white border-[3px] border-solid border-[#D73860] aspect-square h-[11px] mt-0.5" />
        <div className={tailwindClasses.text}>
          Anchor Keyword <br /> (Red Border)
        </div>
      </div>

      {/* Display-only entry (no show/hide toggle) for the computed center marker.
          A rotated square renders the diamond; its fill is neutral because the
          diamond's actual color varies with the cluster's trend. */}
      {showCenterMarker && (
        <div className={tailwindClasses.container}>
          <div className="bg-[#BDB9C1] aspect-square h-[9px] mt-1 rotate-45" />
          <div className={tailwindClasses.text}>
            Cluster Weighted <br /> Average (Diamond)
          </div>
        </div>
      )}
    </div>
  )
}

export default ColorLegends;